<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <!-- Título y subtítulo -->
      <v-row justify="start" align="start" class="ma-0 mb-4 mt-5">
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #193D6E;">
            Contratos activos de factoraje
          </div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            Aquí puedes revisar todos los contratos firmados con tus clientes para ceder facturas.
          </div>
        </v-col>
      </v-row>

      <!-- Buscador -->
      <v-row class="ma-0 mb-4" style="align-items: center;">
        <v-col cols="12" sm="4" md="3" class="pl-0">
          <v-text-field
            v-model="search"
            label="Buscar cliente"
            hide-details
            append-icon="mdi-magnify"
            outlined
            style="font-family: 'montserrat-medium'; border-radius: 20px; background-color: white;"
          />
        </v-col>
      </v-row>

      <!-- Tabla de contratos -->
      <v-data-table
        class="d-none d-sm-block"
        :headers="headers"
        :items="contratos"
        :search="search"
        hide-default-header
      >
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">Acreditado</th>
              <th class="header__title center">Deudor</th>
              <th class="header__title center">Fecha</th>
              <th class="header__title center">Línea autorizada</th>
              <th class="header__title center">Tasa</th>
              <th class="header__title center">Días crédito</th>
              <th class="header__title center">Firmas</th>
              <th class="header__title center">Contrato</th>
            </tr>
          </thead>
        </template>

        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.cedente_name }}</td>
              <td class="table__item">{{ item.deudor_name }}</td>
              <td class="table__item center">{{ formatDate(item.created_at) }}</td>
              <td class="table__item center">${{ formatMoney(item.linea_autorizada) }} USD</td>
              <td class="table__item center">{{ item.tasa_interes }}%</td>
              <td class="table__item center">{{ item.dias_credito }} días</td>
              <td class="table__item center">
                <v-chip
                  v-for="rol in ['Deudor', 'Cedente', 'Admin']"
                  :key="rol"
                  :color="item.signatures.some(sig => sig.role.toLowerCase() === rol.toLowerCase()) ? 'green' : 'grey'"
                  small
                  class="ma-1 white--text"
                >
                  {{ rol }}
                </v-chip>
              </td>
              <td class="table__item center">
                <v-btn icon color="#0075B8" class="white--text" @click="abrirDocumento(item)">
                  <v-icon color="primary">mdi-eye</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>

      <!-- Diálogo contrato -->
      <v-dialog v-model="dialogContrato" max-width="800" scrollable persistent>
        <v-card>
          <v-card-title class="headline" style="font-family: 'montserrat-bold';">
            Contrato con {{ contratoSeleccionado?.cliente }}
          </v-card-title>
          <v-card-text>
            <v-sheet
              height="300"
              class="grey lighten-4 px-4 py-4"
              style="overflow-y: auto; border-radius: 12px;"
            >
              <div v-html="contractHtml"></div>
            </v-sheet>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="dialogContrato = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      dialogContrato: false,
      contratoSeleccionado: null,
      contractHtml: '',
      headers: [
        { text: 'Cliente', value: 'cliente' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Línea autorizada', value: 'linea' },
        { text: 'Tasa de interés', value: 'tasa' },
        { text: 'Días de crédito', value: 'plazo' },
        { text: 'Firmas', value: 'firmas' },
        { text: '', value: 'acciones', sortable: false }
      ],
      contratos: [],
    };
  },
  methods: {
    async getContracts() {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/contracts/client/contracts`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.contratos = response.data.contracts;
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    abrirDocumento(doc) {
      window.open(`${doc.file_url}`, '_blank');
    },
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY");
      return formattedDate;
    },
  },
  beforeMount() {
    this.getContracts();
  },
};
</script>

<style scoped>
.header__title {
  font-family: 'montserrat-semibold';
  font-size: 13px;
  padding: 12px;
}
.header__title.left {
  text-align: left;
}
.header__title.center {
  text-align: center;
}
</style>
